import Icon from "@portal/components/atoms/icons";

export const GetIconForPlanningPage = (index: number) => {
  const size = "xxlarge";
  if (index === 0)
    return (
      <div className="p-3">
        <Icon name={"piggyBankIcon"} size="large" />
      </div>
    );
  if (index === 1) return <Icon name={"coupleWithVespaIcon"} size={size} />;
  if (index === 2) return <Icon name={"womanWithGoalsYellowIcon"} size={size} />;
  if (index === 3) return <Icon name={"manWithGraphsYellowIcon"} size={size} />;
  if (index === 4) return <Icon name={"manWithCheckboxesBlueIcon"} size={size} />;
};
